var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('FilterGroupWrapper', {
    attrs: {
      "name": _vm.name,
      "toggle": _vm.initialToggle,
      "active-count": _vm.activeCount
    }
  }, [_c('div', {
    staticClass: "range-filter"
  }, [_c('div', {
    staticClass: "range-filter__col"
  }, [_c('RangeInput', {
    attrs: {
      "value": _vm.minValue,
      "min": _vm.filter.min,
      "max": _vm.maxValue,
      "disabled": _vm.filter.min === _vm.filter.max,
      "prefix": "От"
    },
    on: {
      "change": function ($event) {
        return _vm.debounceChange(_vm.filter.from.property, _vm.minValue, $event);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "range-filter__col"
  }, [_c('RangeInput', {
    attrs: {
      "value": _vm.maxValue,
      "min": _vm.minValue,
      "max": _vm.filter.max,
      "disabled": _vm.filter.min === _vm.filter.max,
      "prefix": "До"
    },
    on: {
      "change": function ($event) {
        return _vm.debounceChange(_vm.filter.to.property, _vm.maxValue, $event);
      }
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }